'use client';

import { atom } from 'jotai';

// An atom holding the partner app identifier.
export const FavouriteFeedCompleted = atom<boolean>(false);
